// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../../__generated__/schema.graphql.types";
import { ClientsFirstAppointmentFragmentDoc } from "../../fragments/clientsFirstAppointment.graphql.types";
import { AppointmentTelehealthIconFieldsFragmentDoc } from "../../fragments/telehealth/telehealthFields.graphql.types";
import { UserMedspaConfigFragmentDoc } from "../../fragments/userMedspaConfig.graphql.types";
import { AppointmentServiceProviderBasicInfoFragmentDoc } from "./appointmentServiceProviderBasicInfo.graphql.types";

const defaultOptions = {} as const;
export type AppointmentFieldsFragment = {
  __typename?: "appointment";
  id: string;
  startTime?: string | null;
  endTime?: string | null;
  status: string;
  reviewStatus: string;
  invoice?: { __typename?: "invoice"; id: string; status: string } | null;
  client?: {
    __typename?: "client";
    id: string;
    firstName: string;
    lastName: string;
    note: string;
    hadAdverseReaction: boolean;
    formSubmissions: Array<{
      __typename?: "formSubmission";
      id: string;
      gfeStatus: string;
      submittedAt?: string | null;
      archivedAt?: string | null;
      medspa: { __typename?: "medspa"; id: string };
    }>;
    consentFormSignatures: Array<{
      __typename?: "consentFormSignature";
      id: string;
      appointmentId?: string | null;
      signedAt?: string | null;
      consentForm: {
        __typename?: "consentForm";
        id: string;
        sendOnce: boolean;
      };
    }>;
    hasItemsInWallet: {
      __typename?: "walletTransactionAggregate";
      aggregate?: {
        __typename?: "walletTransactionAggregateFields";
        sum?: {
          __typename?: "walletTransactionSumFields";
          amount?: string | null;
        } | null;
      } | null;
    };
    clientMemberships: Array<{
      __typename?: "ClientMembership";
      id: string;
      membership: { __typename?: "Membership"; id: string; title: string };
    }>;
    appointments: Array<{ __typename?: "appointment"; id: string }>;
  } | null;
  appointmentServices: Array<{
    __typename?: "AppointmentService";
    id: string;
    startTime?: string | null;
    endTime?: string | null;
    gfeStatus?: string | null;
    serviceMenuItem: {
      __typename?: "MedspaServiceMenuItem";
      id: string;
      name: string;
    };
    provider?: {
      __typename?: "userMedspa";
      id: string;
      color?: string | null;
      initials?: string | null;
      user: {
        __typename?: "user";
        id: string;
        firstName: string;
        lastName: string;
      };
    } | null;
  }>;
  provider: {
    __typename?: "user";
    id: string;
    firstName: string;
    lastName: string;
    userMedspas: Array<{
      __typename?: "userMedspa";
      id: string;
      color?: string | null;
      initials?: string | null;
    }>;
  };
};

export type MultiProviderAppointmentFieldsFragment = {
  __typename?: "appointment";
  id: string;
  startTime?: string | null;
  endTime?: string | null;
  status: string;
  reviewStatus: string;
  invoice?: { __typename?: "invoice"; id: string; status: string } | null;
  client?: {
    __typename?: "client";
    id: string;
    firstName: string;
    lastName: string;
    note: string;
    hadAdverseReaction: boolean;
    formSubmissions: Array<{
      __typename?: "formSubmission";
      id: string;
      gfeStatus: string;
      submittedAt?: string | null;
      archivedAt?: string | null;
      medspa: { __typename?: "medspa"; id: string };
    }>;
    consentFormSignatures: Array<{
      __typename?: "consentFormSignature";
      id: string;
      appointmentId?: string | null;
      signedAt?: string | null;
      consentForm: {
        __typename?: "consentForm";
        id: string;
        sendOnce: boolean;
      };
    }>;
    hasItemsInWallet: {
      __typename?: "walletTransactionAggregate";
      aggregate?: {
        __typename?: "walletTransactionAggregateFields";
        sum?: {
          __typename?: "walletTransactionSumFields";
          amount?: string | null;
        } | null;
      } | null;
    };
    clientMemberships: Array<{
      __typename?: "ClientMembership";
      id: string;
      membership: { __typename?: "Membership"; id: string; title: string };
    }>;
    appointments: Array<{ __typename?: "appointment"; id: string }>;
  } | null;
  appointmentServices: Array<{
    __typename?: "AppointmentService";
    id: string;
    startTime?: string | null;
    endTime?: string | null;
    gfeStatus?: string | null;
    serviceMenuItem: {
      __typename?: "MedspaServiceMenuItem";
      id: string;
      name: string;
    };
    provider?: {
      __typename?: "userMedspa";
      id: string;
      color?: string | null;
      initials?: string | null;
      user: {
        __typename?: "user";
        id: string;
        firstName: string;
        lastName: string;
      };
    } | null;
  }>;
  provider: {
    __typename?: "user";
    id: string;
    firstName: string;
    lastName: string;
    userMedspas: Array<{
      __typename?: "userMedspa";
      id: string;
      color?: string | null;
      initials?: string | null;
    }>;
  };
};

export type AppointmentsQueryVariables = Types.Exact<{
  date: Types.Scalars["timestamptz"]["input"];
  medspaId: Types.Scalars["bigint"]["input"];
  provider: Types.Scalars["bigint"]["input"];
  appointmentServicesProvidersCropExp?: Types.InputMaybe<Types.UserMedspaBoolExp>;
}>;

export type AppointmentsQuery = {
  __typename?: "query_root";
  appointment: Array<{
    __typename?: "appointment";
    id: string;
    startTime?: string | null;
    endTime?: string | null;
    status: string;
    reviewStatus: string;
    isAppointmentTelehealth?: boolean | null;
    invoice?: { __typename?: "invoice"; id: string; status: string } | null;
    client?: {
      __typename?: "client";
      id: string;
      firstName: string;
      lastName: string;
      note: string;
      hadAdverseReaction: boolean;
      formSubmissions: Array<{
        __typename?: "formSubmission";
        id: string;
        gfeStatus: string;
        submittedAt?: string | null;
        archivedAt?: string | null;
        medspa: { __typename?: "medspa"; id: string };
      }>;
      consentFormSignatures: Array<{
        __typename?: "consentFormSignature";
        id: string;
        appointmentId?: string | null;
        signedAt?: string | null;
        consentForm: {
          __typename?: "consentForm";
          id: string;
          sendOnce: boolean;
        };
      }>;
      hasItemsInWallet: {
        __typename?: "walletTransactionAggregate";
        aggregate?: {
          __typename?: "walletTransactionAggregateFields";
          sum?: {
            __typename?: "walletTransactionSumFields";
            amount?: string | null;
          } | null;
        } | null;
      };
      clientMemberships: Array<{
        __typename?: "ClientMembership";
        id: string;
        membership: { __typename?: "Membership"; id: string; title: string };
      }>;
      appointments: Array<{ __typename?: "appointment"; id: string }>;
    } | null;
    appointmentServices: Array<{
      __typename?: "AppointmentService";
      id: string;
      startTime?: string | null;
      endTime?: string | null;
      gfeStatus?: string | null;
      serviceMenuItem: {
        __typename?: "MedspaServiceMenuItem";
        id: string;
        name: string;
      };
      provider?: {
        __typename?: "userMedspa";
        id: string;
        color?: string | null;
        initials?: string | null;
        user: {
          __typename?: "user";
          id: string;
          firstName: string;
          lastName: string;
        };
      } | null;
    }>;
    provider: {
      __typename?: "user";
      id: string;
      firstName: string;
      lastName: string;
      userMedspas: Array<{
        __typename?: "userMedspa";
        id: string;
        color?: string | null;
        initials?: string | null;
      }>;
    };
    telehealthAppointmentDetails?: {
      __typename?: "TelehealthAppointmentDetails";
      appointmentId: string;
      videoLink?: string | null;
    } | null;
  }>;
};

export type NextAppointmentForClientQueryVariables = Types.Exact<{
  clientId: Types.Scalars["bigint"]["input"];
  medspaId: Types.Scalars["bigint"]["input"];
  appointmentServicesProvidersCropExp?: Types.InputMaybe<Types.UserMedspaBoolExp>;
}>;

export type NextAppointmentForClientQuery = {
  __typename?: "query_root";
  appointment: Array<{
    __typename?: "appointment";
    id: string;
    startTime?: string | null;
    endTime?: string | null;
    status: string;
    reviewStatus: string;
    invoice?: { __typename?: "invoice"; id: string; status: string } | null;
    client?: {
      __typename?: "client";
      id: string;
      firstName: string;
      lastName: string;
      note: string;
      hadAdverseReaction: boolean;
      formSubmissions: Array<{
        __typename?: "formSubmission";
        id: string;
        gfeStatus: string;
        submittedAt?: string | null;
        archivedAt?: string | null;
        medspa: { __typename?: "medspa"; id: string };
      }>;
      consentFormSignatures: Array<{
        __typename?: "consentFormSignature";
        id: string;
        appointmentId?: string | null;
        signedAt?: string | null;
        consentForm: {
          __typename?: "consentForm";
          id: string;
          sendOnce: boolean;
        };
      }>;
      hasItemsInWallet: {
        __typename?: "walletTransactionAggregate";
        aggregate?: {
          __typename?: "walletTransactionAggregateFields";
          sum?: {
            __typename?: "walletTransactionSumFields";
            amount?: string | null;
          } | null;
        } | null;
      };
      clientMemberships: Array<{
        __typename?: "ClientMembership";
        id: string;
        membership: { __typename?: "Membership"; id: string; title: string };
      }>;
      appointments: Array<{ __typename?: "appointment"; id: string }>;
    } | null;
    appointmentServices: Array<{
      __typename?: "AppointmentService";
      id: string;
      startTime?: string | null;
      endTime?: string | null;
      gfeStatus?: string | null;
      serviceMenuItem: {
        __typename?: "MedspaServiceMenuItem";
        id: string;
        name: string;
      };
      provider?: {
        __typename?: "userMedspa";
        id: string;
        color?: string | null;
        initials?: string | null;
        user: {
          __typename?: "user";
          id: string;
          firstName: string;
          lastName: string;
        };
      } | null;
    }>;
    provider: {
      __typename?: "user";
      id: string;
      firstName: string;
      lastName: string;
      userMedspas: Array<{
        __typename?: "userMedspa";
        id: string;
        color?: string | null;
        initials?: string | null;
      }>;
    };
  }>;
};

export const AppointmentFieldsFragmentDoc = gql`
  fragment AppointmentFields on appointment {
    id
    startTime
    endTime
    invoice {
      id
      status
    }
    status
    reviewStatus
    client {
      id
      firstName
      lastName
      note
      formSubmissions {
        id
        gfeStatus
        submittedAt
        archivedAt
        medspa {
          id
        }
      }
      consentFormSignatures(
        where: {
          expiredAt: { _isNull: true }
          consentForm: { deletedAt: { _isNull: true } }
        }
      ) {
        id
        appointmentId
        signedAt
        consentForm {
          id
          sendOnce
        }
      }
      hadAdverseReaction
      hasItemsInWallet: walletTransactionsAggregate {
        aggregate {
          sum {
            amount
          }
        }
      }
      clientMemberships(where: { status: { _neq: "canceled" } }) {
        id
        membership {
          id
          title
        }
      }
      ...ClientsFirstAppointment
    }
    appointmentServices(
      where: { provider: $appointmentServicesProvidersCropExp }
      orderBy: { startTime: ASC }
    ) {
      id
      startTime
      endTime
      gfeStatus
      serviceMenuItem {
        id
        name
      }
      ...AppointmentServiceProviderBasicInfo
    }
    provider {
      id
      firstName
      lastName
      userMedspas(where: { medspa: { id: { _eq: $medspaId } } }) {
        ...UserMedspaConfig
      }
    }
  }
  ${ClientsFirstAppointmentFragmentDoc}
  ${AppointmentServiceProviderBasicInfoFragmentDoc}
  ${UserMedspaConfigFragmentDoc}
`;
export const MultiProviderAppointmentFieldsFragmentDoc = gql`
  fragment MultiProviderAppointmentFields on appointment {
    id
    startTime
    endTime
    invoice {
      id
      status
    }
    status
    reviewStatus
    client {
      id
      firstName
      lastName
      note
      formSubmissions {
        id
        gfeStatus
        submittedAt
        archivedAt
        medspa {
          id
        }
      }
      consentFormSignatures(
        where: {
          expiredAt: { _isNull: true }
          consentForm: { deletedAt: { _isNull: true } }
        }
      ) {
        id
        appointmentId
        signedAt
        consentForm {
          id
          sendOnce
        }
      }
      hadAdverseReaction
      hasItemsInWallet: walletTransactionsAggregate {
        aggregate {
          sum {
            amount
          }
        }
      }
      clientMemberships(where: { status: { _neq: "canceled" } }) {
        id
        membership {
          id
          title
        }
      }
      ...ClientsFirstAppointment
    }
    appointmentServices(
      where: { provider: $appointmentServicesProvidersCropExp }
      orderBy: { startTime: ASC }
    ) {
      id
      startTime
      endTime
      gfeStatus
      serviceMenuItem {
        id
        name
      }
      ...AppointmentServiceProviderBasicInfo
    }
    provider {
      id
      firstName
      lastName
      userMedspas {
        ...UserMedspaConfig
      }
    }
  }
  ${ClientsFirstAppointmentFragmentDoc}
  ${AppointmentServiceProviderBasicInfoFragmentDoc}
  ${UserMedspaConfigFragmentDoc}
`;
export const AppointmentsDocument = gql`
  query Appointments(
    $date: timestamptz!
    $medspaId: bigint!
    $provider: bigint!
    $appointmentServicesProvidersCropExp: userMedspaBoolExp = {}
  ) {
    appointment(
      where: {
        startTime: { _gt: $date }
        provider: { id: { _eq: $provider } }
        status: { _nin: ["cancelled", "cancelled_late"] }
        medspa: { id: { _eq: $medspaId } }
      }
      orderBy: { startTime: ASC }
    ) {
      ...AppointmentFields
      ...AppointmentTelehealthIconFields
    }
  }
  ${AppointmentFieldsFragmentDoc}
  ${AppointmentTelehealthIconFieldsFragmentDoc}
`;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      medspaId: // value for 'medspaId'
 *      provider: // value for 'provider'
 *      appointmentServicesProvidersCropExp: // value for 'appointmentServicesProvidersCropExp'
 *   },
 * });
 */
export function useAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppointmentsQuery,
    AppointmentsQueryVariables
  > &
    (
      | { variables: AppointmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppointmentsQuery, AppointmentsQueryVariables>(
    AppointmentsDocument,
    options
  );
}
export function useAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppointmentsQuery,
    AppointmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppointmentsQuery, AppointmentsQueryVariables>(
    AppointmentsDocument,
    options
  );
}
export function useAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppointmentsQuery,
        AppointmentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AppointmentsQuery, AppointmentsQueryVariables>(
    AppointmentsDocument,
    options
  );
}
export type AppointmentsQueryHookResult = ReturnType<
  typeof useAppointmentsQuery
>;
export type AppointmentsLazyQueryHookResult = ReturnType<
  typeof useAppointmentsLazyQuery
>;
export type AppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useAppointmentsSuspenseQuery
>;
export type AppointmentsQueryResult = Apollo.QueryResult<
  AppointmentsQuery,
  AppointmentsQueryVariables
>;
export const NextAppointmentForClientDocument = gql`
  query NextAppointmentForClient(
    $clientId: bigint!
    $medspaId: bigint!
    $appointmentServicesProvidersCropExp: userMedspaBoolExp = {}
  ) {
    appointment(
      where: {
        clientId: { _eq: $clientId }
        medspaId: { _eq: $medspaId }
        startTime: { _gt: "now()" }
      }
      limit: 1
    ) {
      ...AppointmentFields
    }
  }
  ${AppointmentFieldsFragmentDoc}
`;

/**
 * __useNextAppointmentForClientQuery__
 *
 * To run a query within a React component, call `useNextAppointmentForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextAppointmentForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextAppointmentForClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      medspaId: // value for 'medspaId'
 *      appointmentServicesProvidersCropExp: // value for 'appointmentServicesProvidersCropExp'
 *   },
 * });
 */
export function useNextAppointmentForClientQuery(
  baseOptions: Apollo.QueryHookOptions<
    NextAppointmentForClientQuery,
    NextAppointmentForClientQueryVariables
  > &
    (
      | { variables: NextAppointmentForClientQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NextAppointmentForClientQuery,
    NextAppointmentForClientQueryVariables
  >(NextAppointmentForClientDocument, options);
}
export function useNextAppointmentForClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NextAppointmentForClientQuery,
    NextAppointmentForClientQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NextAppointmentForClientQuery,
    NextAppointmentForClientQueryVariables
  >(NextAppointmentForClientDocument, options);
}
export function useNextAppointmentForClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NextAppointmentForClientQuery,
        NextAppointmentForClientQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NextAppointmentForClientQuery,
    NextAppointmentForClientQueryVariables
  >(NextAppointmentForClientDocument, options);
}
export type NextAppointmentForClientQueryHookResult = ReturnType<
  typeof useNextAppointmentForClientQuery
>;
export type NextAppointmentForClientLazyQueryHookResult = ReturnType<
  typeof useNextAppointmentForClientLazyQuery
>;
export type NextAppointmentForClientSuspenseQueryHookResult = ReturnType<
  typeof useNextAppointmentForClientSuspenseQuery
>;
export type NextAppointmentForClientQueryResult = Apollo.QueryResult<
  NextAppointmentForClientQuery,
  NextAppointmentForClientQueryVariables
>;
